import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ErrorPage } from './components/error-page/ErrorPage';
import { constants } from './constants';
import { AnonymousLayout } from './routes/_anonymous';
import { AuthLayout } from './routes/_anonymous._auth';
import { ForgetRoute } from './routes/_anonymous._auth.forget';
import { LoginRoute } from './routes/_anonymous._auth.login';
import { SubscribeRoute } from './routes/_anonymous._auth.subscribe';
import { ShareRoute } from './routes/_anonymous.share.$jwtToken';
import { AuthenticatedLayout } from './routes/_authenticated';
import { HomeRoute } from './routes/_authenticated._index';
import { BookerRoute } from './routes/_authenticated.booker';
import { ReceptionistsRoute } from './routes/_authenticated.receptionists';
import { StatsRoute } from './routes/_authenticated.stats';
import { TripsRoute } from './routes/_authenticated.trips';
import { TripRoute } from './routes/_authenticated.trips.$tripKey';
import { TakeOverRoute } from './routes/takeover';
import { SHARE_ROUTE_ID } from './utils/navigation';

const router = createBrowserRouter(
  constants.isHotels
    ? [
        { path: '/takeover', element: <TakeOverRoute />, errorElement: <ErrorPage /> },
        {
          element: <AnonymousLayout />,
          errorElement: <ErrorPage />,
          children: [
            {
              element: <AuthLayout />,
              errorElement: <ErrorPage />,
              children: [
                { path: '/login', element: <LoginRoute />, errorElement: <ErrorPage /> },
                { path: '/subscribe', element: <SubscribeRoute />, errorElement: <ErrorPage /> },
                { path: '/reset-password', element: <ForgetRoute />, errorElement: <ErrorPage /> },
              ],
            },
            { path: '/share/:jwtToken', element: <ShareRoute />, errorElement: <ErrorPage />, id: SHARE_ROUTE_ID },
          ],
        },
        {
          element: <AuthenticatedLayout />,
          errorElement: <ErrorPage />,
          children: [
            { path: '/', element: <HomeRoute />, errorElement: <ErrorPage /> },
            { path: '/booker', element: <BookerRoute />, errorElement: <ErrorPage /> },
            { path: '/trips', element: <TripsRoute />, errorElement: <ErrorPage /> },
            { path: '/trips/:tripKey', element: <TripRoute />, errorElement: <ErrorPage /> },
            { path: '/receptionists', element: <ReceptionistsRoute />, errorElement: <ErrorPage /> },
            { path: '/statistics', element: <StatsRoute />, errorElement: <ErrorPage /> },
          ],
        },
      ]
    : [
        {
          element: <AnonymousLayout />,
          errorElement: <ErrorPage />,
          children: [
            { path: '/share/:jwtToken', element: <ShareRoute />, errorElement: <ErrorPage />, id: SHARE_ROUTE_ID },
          ],
        },
      ],
  {
    basename: constants.basename,
  },
);

export const Router = () => {
  return <RouterProvider router={router} />;
};
